module.exports = __webpack_public_path__ + "img/guide.a1f92a13.png";